// ISO 3166-1 alpha-2 country list. Flags are rendered as PNGs from flagcdn.com
// so they look identical on every OS/browser regardless of emoji support.
import React from "react";

export const COUNTRIES = [
  { code: "IE", name: "Ireland" },
  { code: "PL", name: "Poland" },
  { code: "RS", name: "Serbia" },
  { code: "IN", name: "India" },
  { code: "GB", name: "United Kingdom" },
  { code: "US", name: "United States" },
  { code: "DE", name: "Germany" },
  { code: "FR", name: "France" },
  { code: "ES", name: "Spain" },
  { code: "IT", name: "Italy" },
  { code: "NL", name: "Netherlands" },
  { code: "BE", name: "Belgium" },
  { code: "PT", name: "Portugal" },
  { code: "CZ", name: "Czech Republic" },
  { code: "SK", name: "Slovakia" },
  { code: "HU", name: "Hungary" },
  { code: "RO", name: "Romania" },
  { code: "BG", name: "Bulgaria" },
  { code: "HR", name: "Croatia" },
  { code: "SI", name: "Slovenia" },
  { code: "AT", name: "Austria" },
  { code: "CH", name: "Switzerland" },
  { code: "SE", name: "Sweden" },
  { code: "NO", name: "Norway" },
  { code: "DK", name: "Denmark" },
  { code: "FI", name: "Finland" },
  { code: "GR", name: "Greece" },
  { code: "TR", name: "Türkiye" },
  { code: "UA", name: "Ukraine" },
  { code: "BA", name: "Bosnia & Herzegovina" },
  { code: "AE", name: "United Arab Emirates" },
  { code: "SG", name: "Singapore" },
  { code: "HK", name: "Hong Kong" },
  { code: "AU", name: "Australia" },
  { code: "CA", name: "Canada" },
  { code: "BR", name: "Brazil" },
  { code: "MX", name: "Mexico" },
  { code: "ZA", name: "South Africa" },
  { code: "PK", name: "Pakistan" },
  { code: "PH", name: "Philippines" },
  { code: "ID", name: "Indonesia" },
  { code: "MY", name: "Malaysia" },
  { code: "JP", name: "Japan" },
  { code: "KR", name: "South Korea" },
  { code: "CN", name: "China" },
];

const map = Object.fromEntries(COUNTRIES.map((c) => [c.code, c]));

export function countryByCode(code) {
  if (!code) return null;
  return map[code.toUpperCase()] || null;
}

// Returns a small flag <img> for a given ISO alpha-2 code (or null).
// Uses flagcdn.com which serves crisp PNG flags by ISO code — identical on every device.
// Available heights: 20, 40, 60, 80, 120, 240. We pick h20 (1x) + h40 (2x retina).
export function flagFor(code, height = 14) {
  const c = countryByCode(code);
  if (!c) return null;
  const lc = c.code.toLowerCase();
  return (
    <img
      src={`https://flagcdn.com/h20/${lc}.png`}
      srcSet={`https://flagcdn.com/h40/${lc}.png 2x`}
      alt={c.code}
      title={c.name}
      width={Math.round(height * 1.5)}
      height={height}
      style={{ display: "inline-block", verticalAlign: "middle", borderRadius: 1, boxShadow: "0 0 0 1px rgba(255,255,255,0.08)" }}
      loading="lazy"
    />
  );
}
